"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

var _underscore = _interopRequireDefault(require("underscore"));

var _backbone = _interopRequireDefault(require("backbone"));

var _scriptjs = _interopRequireDefault(require("scriptjs"));

var _Global = _interopRequireDefault(require("models/Global"));

var _config = _interopRequireDefault(require("config"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.googleMapReady = function () {
  _backbone.default.trigger('google-map-loaded');
};

var GoogleMapsLoader = _backbone.default.View.extend({
  initialize: function initialize() {
    this.loadMap();
  },
  loadMap: function loadMap() {
    if (!window.google) {
      (0, _scriptjs.default)(['https://maps.googleapis.com/maps/api/js?v=3.exp&key=' + _config.default.googleMapsApiKey + '&libraries=places&sensor=false&callback=googleMapReady'], function (response) {});
      return;
    }
  }
});

var _default = GoogleMapsLoader;
exports.default = _default;